/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return h; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRef", function() { return createRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rerender", function() { return rerender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "options", function() { return options; });
var VNode = function VNode() {};

var options = {};

var stack = [];

var EMPTY_CHILDREN = [];

function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

function applyRef(ref, value) {
  if (ref) {
    if (typeof ref == 'function') ref(value);else ref.current = value;
  }
}

var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p;
	while (p = items.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {} else if (name === 'ref') {
		applyRef(old, null);
		applyRef(value, node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		try {
			node[name] = value == null ? '' : value;
		} catch (e) {}
		if ((value == null || value === false) && name != 'spellcheck') node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));

		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

var mounts = [];

var diffLevel = 0;

var isSvgMode = false;

var hydrating = false;

function flushMounts() {
	var c;
	while (c = mounts.shift()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	if (!diffLevel++) {
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	if (! --diffLevel) {
		hydrating = false;

		if (!componentRoot) flushMounts();
	}

	return ret;
}

function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	if (typeof vnode === 'string' || typeof vnode === 'number') {
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			}
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	} else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	diffAttributes(out, vnode.attributes, props);

	isSvgMode = prevSvgMode;

	return out;
}

function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			} else if (min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		unmountComponent(component);
	} else {
		if (node['__preactattr_'] != null) applyRef(node['__preactattr_'].ref, null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

function diffAttributes(dom, attrs, old) {
	var name;

	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

var recyclerComponents = [];

function createComponent(Ctor, props, context) {
	var inst,
	    i = recyclerComponents.length;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	while (i--) {
		if (recyclerComponents[i].constructor === Ctor) {
			inst.nextBase = recyclerComponents[i].nextBase;
			recyclerComponents.splice(i, 1);
			return inst;
		}
	}

	return inst;
}

function doRender(props, state, context) {
	return this.constructor(props, context);
}

function setComponentProps(component, props, renderMode, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	component.__ref = props.ref;
	component.__key = props.key;
	delete props.ref;
	delete props.key;

	if (typeof component.constructor.getDerivedStateFromProps === 'undefined') {
		if (!component.base || mountAll) {
			if (component.componentWillMount) component.componentWillMount();
		} else if (component.componentWillReceiveProps) {
			component.componentWillReceiveProps(props, context);
		}
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (renderMode !== 0) {
		if (renderMode === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	applyRef(component.__ref, component);
}

function renderComponent(component, renderMode, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    snapshot = previousContext,
	    rendered,
	    inst,
	    cbase;

	if (component.constructor.getDerivedStateFromProps) {
		state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
		component.state = state;
	}

	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		if (isUpdate && component.getSnapshotBeforeUpdate) {
			snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || renderMode === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.push(component);
	} else if (!skip) {

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, snapshot);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	while (component._renderCallbacks.length) {
		component._renderCallbacks.pop().call(component);
	}if (!diffLevel && !isChild) flushMounts();
}

function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;

			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] != null) applyRef(base['__preactattr_'].ref, null);

		component.nextBase = base;

		removeNode(base);
		recyclerComponents.push(component);

		removeChildren(base);
	}

	applyRef(component.__ref, null);
}

function Component(props, context) {
	this._dirty = true;

	this.context = context;

	this.props = props;

	this.state = this.state || {};

	this._renderCallbacks = [];
}

extend(Component.prototype, {
	setState: function setState(state, callback) {
		if (!this.prevState) this.prevState = this.state;
		this.state = extend(extend({}, this.state), typeof state === 'function' ? state(this.state, this.props) : state);
		if (callback) this._renderCallbacks.push(callback);
		enqueueRender(this);
	},
	forceUpdate: function forceUpdate(callback) {
		if (callback) this._renderCallbacks.push(callback);
		renderComponent(this, 2);
	},
	render: function render() {}
});

function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

function createRef() {
	return {};
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	createRef: createRef,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};

/* harmony default export */ __webpack_exports__["default"] = (preact);

//# sourceMappingURL=preact.mjs.map


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(22)();
}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.FontPageStore = exports.FontPageActions = exports.filteredFontCollection = exports.fullFontCollection = undefined;

var _signalsLite = __webpack_require__(10);

// wp_enqueue_script: Backbone

var FontModel = Backbone.Model.extend({
  idAttribute: 'ID'
});
var FontCollection = Backbone.Collection.extend({
  model: FontModel,
  url: '/wp-json/wp/v2/catalogs?per_page=100&order=asc&orderby=menu_order&_embed'
});

var fullFontCollection = new FontCollection();
fullFontCollection.comparator = 'title';
var filteredFontCollection = fullFontCollection.clone();

// copy the models when loaded (sync gets called on load)
fullFontCollection.on('sync', function () {
  filteredFontCollection.reset(fullFontCollection.models);
});

var FontPageActions = {
  filterByClassification: function filterByClassification(filter) {
    // Updates FontPageStore through the Backbone.js event system.
    if (filter !== 'all') {
      filteredFontCollection.reset(fullFontCollection.filter(function (model) {
        var category = model.attributes._embedded['wp:term'];
        return category.length > 0 && category[0].length && category[0][0].slug === filter;
      }));
    } else {
      filteredFontCollection.reset(fullFontCollection.models);
    }
    FontPageStore.updateListFilter(filter);
    this.makeListVisible();
  },
  updateAllSampleText: function updateAllSampleText(sampleText) {
    FontPageStore.updateAllSampleText(sampleText);
    // this.makeListVisible()
  },
  setFilteredModels: function setFilteredModels(models) {
    FontPageStore.updateListFilter('custom');
    filteredFontCollection.reset(models);
    this.makeListVisible();
  },
  addModelToPage: function addModelToPage(model) {
    // Triggers `added` event on Backbone.Collection
    filteredFontCollection.add(model);
    // :TODO: Check and see if all the fonts have been added
    // to filtered, and if so, set 'all' filter.
    FontPageStore.updateListFilter('custom');
    this.makeListVisible();
  },
  removeModelFromPage: function removeModelFromPage(model) {
    // Triggers `removed` event on Backbone.Collection
    filteredFontCollection.remove(model);
    FontPageStore.updateListFilter('custom');
    this.makeListVisible();
  },
  makeListVisible: function makeListVisible() {
    FontPageStore.setListVisible();
  },
  makeListHidden: function makeListHidden() {
    FontPageStore.setListHidden();
  }
};

var FontPageStore = {
  sampleText: '',
  updateAllSampleText: function updateAllSampleText(sampleText) {
    this.sampleText = sampleText;
    this.allSampleTextChanged.broadcast(this.sampleText, this);
  },

  allSampleTextChanged: new _signalsLite.SignalLite(),

  activeFilter: 'all',
  updateListFilter: function updateListFilter(filter) {
    if (this.activeFilter != filter) {
      this.activeFilter = filter;
      this.listFilterChanged.broadcast(filter);
    }
  },
  getListFilter: function getListFilter() {
    return this.activeFilter;
  },

  listFilterChanged: new _signalsLite.SignalLite(),

  updateFullFontList: function updateFullFontList() {
    this.fullFontListChanged.broadcast(fullFontCollection.models);
  },
  getFullFontList: function getFullFontList() {
    return fullFontCollection.models;
  },

  fullFontListChanged: new _signalsLite.SignalLite(),

  updateFilteredFontList: function updateFilteredFontList() {
    this.filteredFontListChanged.broadcast(filteredFontCollection.models);
  },
  getFilteredFontList: function getFilteredFontList() {
    return filteredFontCollection.models;
  },

  filteredFontListChanged: new _signalsLite.SignalLite(),
  pixelRatio: window.devicePixelRatio || 1,
  setPixelRatio: function setPixelRatio(pixelRatio) {
    if (pixelRatio != this.pixelRatio) {
      this.pixelRatio = pixelRatio;
      this.pixelRatioChanged.broadcast(pixelRatio);
    }
  },
  getPixelRatio: function getPixelRatio() {
    return this.pixelRatio;
  },

  pixelRatioChanged: new _signalsLite.SignalLite(),

  isListVisible: /^\/fonts\/?$/.test(window.location.pathname),
  setListVisible: function setListVisible() {
    this.isListVisible = true;
    this.listVisibilityChanged.broadcast(this.isListVisible);
  },
  setListHidden: function setListHidden() {
    this.isListVisible = false;
    this.listVisibilityChanged.broadcast(this.isListVisible);
  },
  getListVisibility: function getListVisibility() {
    return this.isListVisible;
  },

  listVisibilityChanged: new _signalsLite.SignalLite()

  // initialize listeners for FontPageStore
};window.addEventListener('resize', function (event) {
  FontPageStore.setPixelRatio(window.devicePixelRatio || 1);
});
filteredFontCollection.on('reset', FontPageStore.updateFilteredFontList, FontPageStore);
filteredFontCollection.on('add', FontPageStore.updateFilteredFontList, FontPageStore);
filteredFontCollection.on('remove', FontPageStore.updateFilteredFontList, FontPageStore);
fullFontCollection.on('sync', FontPageStore.updateFullFontList, FontPageStore);
fullFontCollection.on('reset', FontPageStore.updateFullFontList, FontPageStore);
//fullFontCollection.on('add', FontPageStore.updateFullFontList, FontPageStore)
//fullFontCollection.on('remove', FontPageStore.updateFullFontList, FontPageStore)

// bootstrap
if (typeof restResults !== 'undefined') {
  fullFontCollection.reset(restResults);
} else {
  fullFontCollection.fetch();
}

exports.fullFontCollection = fullFontCollection;
exports.filteredFontCollection = filteredFontCollection;
exports.FontPageActions = FontPageActions;
exports.FontPageStore = FontPageStore;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(21)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(20)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOM", function() { return DOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Children", function() { return Children; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return render$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClass", function() { return createClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPortal", function() { return createPortal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFactory", function() { return createFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return cloneElement$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isValidElement", function() { return isValidElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findDOMNode", function() { return findDOMNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return unmountComponentAtNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PureComponent", function() { return PureComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_renderSubtreeIntoContainer", function() { return renderSubtreeIntoContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unstable_batchedUpdates", function() { return unstable_batchedUpdates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return extend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "PropTypes", function() { return __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_preact__ = __webpack_require__(0);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRef", function() { return __WEBPACK_IMPORTED_MODULE_1_preact__["createRef"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_context__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_preact_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_preact_context__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_2_preact_context__, "createContext")) __webpack_require__.d(__webpack_exports__, "createContext", function() { return __WEBPACK_IMPORTED_MODULE_2_preact_context__["createContext"]; });







var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(
	' '
);

var REACT_ELEMENT_TYPE = (typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element')) || 0xeac7;

var COMPONENT_WRAPPER_KEY =
	typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = false;
try {
	DEV = "production" !== 'production';
}
catch (e) { }

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function() {
		return this.nodeName;
	},
	set: function(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function() {
		return this.attributes;
	},
	set: function(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].event;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].event = function (e) {
	if (oldEventHook) { e = oldEventHook(e); }
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = __WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode;
__WEBPACK_IMPORTED_MODULE_1_preact__["options"].vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
			attrs = (vnode.attributes = vnode.attributes == null ? {} : extend({}, vnode.attributes));

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || (tag.prototype && 'isReactComponent' in tag.prototype)) {
				if (vnode.children && String(vnode.children) === '') { vnode.children = undefined; }
				if (vnode.children) { attrs.children = vnode.children; }

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		}
		else {
			if (vnode.children && String(vnode.children) === '') { vnode.children = undefined; }
			if (vnode.children) { attrs.children = vnode.children; }

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) { oldVnodeHook(vnode); }
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
		a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) { extend(vnode.attributes, tag.defaultProps); }
	if (a) { extend(vnode.attributes, a); }
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) { if ((shouldSanitize = CAMEL_PROPS.test(i))) { break; } }
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) { prev = null; }

	// default to first Element child
	if (!prev && parent) { prev = parent.firstElementChild; }

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(vnode, parent, prev);
	if (parent) { parent._preactCompatRendered = out && (out._component || { base: out }); }
	if (typeof callback === 'function') { callback(); }
	return (out && out._component) || out;
}

var ContextProvider = function () {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) { callback.call(component, renderContainer); }
	return component;
}

function Portal(props) {
	renderSubtreeIntoContainer(this, props.vnode, props.container);
}

function createPortal(vnode, container) {
	return Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(Portal, { vnode: vnode, container: container });
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		Object(__WEBPACK_IMPORTED_MODULE_1_preact__["render"])(Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function(children, fn, ctx) {
		if (children == null) { return null; }
		children = Children.toArray(children);
		if (ctx && ctx !== children) { fn = fn.bind(ctx); }
		return children.map(fn);
	},
	forEach: function(children, fn, ctx) {
		if (children == null) { return null; }
		children = Children.toArray(children);
		if (ctx && ctx !== children) { fn = fn.bind(ctx); }
		children.forEach(fn);
	},
	count: function(children) {
		return (children && children.length) || 0;
	},
	only: function(children) {
		children = Children.toArray(children);
		if (children.length !== 1) { throw new Error('Children.only() expects only one child.'); }
		return children[0];
	},
	toArray: function(children) {
		if (children == null) { return []; }
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		}
		else if (
			obj &&
			typeof obj === 'object' &&
			!isValidElement(obj) &&
			((obj.props && obj.type) || (obj.attributes && obj.nodeName) || obj.children)
		) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) { return Wrapped === true ? Ctor : Wrapped; }

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	upgradeToVNodes(args, 2);
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["h"].apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
		type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [], len = arguments.length - 2;
	while ( len-- > 0 ) children[ len ] = arguments[ len + 2 ];

	if (!isValidElement(element)) { return element; }
	var elementProps = element.attributes || element.props;
	var node = Object(__WEBPACK_IMPORTED_MODULE_1_preact__["h"])(
		element.nodeName || element.type,
		extend({}, elementProps),
		element.children || (elementProps && elementProps.children)
	);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	}
	else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(__WEBPACK_IMPORTED_MODULE_1_preact__["cloneElement"].apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return (
		component._refProxies[name] ||
		(component._refProxies[name] = function (resolved) {
			if (component && component.refs) {
				component.refs[name] = resolved;
				if (resolved === null) {
					delete component._refProxies[name];
					component = null;
				}
			}
		})
	);
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') { return; }
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (
		props.onchange &&
		(nodeName === 'textarea' || (nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type)))
	) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) { a.class = a.className; }
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function() {
		return this.class;
	},
	set: function(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = (void 0); i < arguments.length; i++) {
		if ((obj = arguments$1[i])) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) { if (!(i in b)) { return true; } }
	for (var i$1 in b) { if (a[i$1] !== b[i$1]) { return true; } }
	return false;
}

function findDOMNode(component) {
	return (component && (component.base || (component.nodeType === 1 && component))) || null;
}

function F() { }

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins)
		{ if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(
				mixins[key].concat(proto[key] || ARR),
				key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext'
			);
		} }
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) { ret = {}; }
				for (var key in r)
					{ if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					} }
			}
			else if (typeof r !== 'undefined') { ret = r; }
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([
		propsHook,
		this.componentWillReceiveProps || 'componentWillReceiveProps'
	]);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) { return; }

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (
		c &&
		Array.isArray(c) &&
		c.length === 1 &&
		(typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)
	) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
			propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	__WEBPACK_IMPORTED_MODULE_1_preact__["Component"].call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend((Component$1.prototype = new __WEBPACK_IMPORTED_MODULE_1_preact__["Component"]()), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function() {
		return this.base;
	},

	isMounted: function() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

function unstable_batchedUpdates(callback) {
	callback();
}

var index = {
	version: version,
	DOM: DOM,
	PropTypes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a,
	Children: Children,
	render: render$1,
	hydrate: render$1,
	createClass: createClass,
	createContext: __WEBPACK_IMPORTED_MODULE_2_preact_context__["createContext"],
	createPortal: createPortal,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	createRef: __WEBPACK_IMPORTED_MODULE_1_preact__["createRef"],
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	unstable_batchedUpdates: unstable_batchedUpdates,
	__spread: extend
};

/* harmony default export */ __webpack_exports__["default"] = (index);

//# sourceMappingURL=preact-compat.es.js.map


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* (c) 2012 Kevin Newman
license MIT
www.unfocus.com */
(function (exports) { "use strict";

/**
 * Holds the listener to be called by the Signal (and provides properties for a simple linked list).
 * @author Kevin Newman
 */
function SlotLite( listener, target ) {
  this.next = null; // SlotLite
  this.prev = null; // SlotLite
  this.listener = listener; // Function
  this.target = target;
}

/**
 * A lite version of Robert Penner's AS3 Signals, for JavaScript.
 * @param target The value of this in listeners when broadcasting.
 * @param eachReturn A callback to handle the return value of each listener.
 * @author Kevin Newman
 */
function SignalLite( target, eachReturn )
{
  /**
   * The empty first slot in a linked set.
   * @private
   */
  this.first = new SlotLite;

  /**
   * The last Slot is initially a reference to the same slot as the first.
   * @private
   */
  this.last = this.first;

  /**
   * The value of this in listeners when broadcasting.
   */
  this.target = target;

  /**
   * A callback to handle the return value of each listener.
   */
  this.eachReturn = eachReturn;

  /**
   * A simple flag to say if we are broadcasting. Used by stopDispatch.
   * @private
   */
  this.broadcasting = false;
}

function cutNode( node )
{
  node.prev.next = node.next;
  if ( node.next )
    node.next.prev = node.prev;
  if ( this.last === node )
    this.last = node.prev;
};

SignalLite.prototype = {
  /**
   * Add a listener for this Signal.
   * @param listener The function to be called when the signal fires.
   * @param target The value of this in listeners when broadcasting only this listener.
   */
  add: function( listener, target )
  {
    if ( this.has( listener ) ) return;
    this.last.next = new SlotLite( listener, target );
    this.last.next.prev = this.last;
    this.last = this.last.next;
    return this.target;
  },

  /**
   * Add a listener for this Signal in the first position.
   * Pushes the first item to the second position. If the listener
   * is already registered, it'll move it to the top.
   * @param listener The function to be called when the signal fires.
   * @param target The value of this in listeners when broadcasting only this listener.
   */
  addToTop: function( listener, target )
  {
    if ( this.has( listener ) ) {
      this.remove( listener );
      this.addToTop( listener );
    }
    var slot = new SlotLite( listener, target );
    slot.next = this.first.next;
    slot.prev = this.first;
    this.first.next.prev = slot;
    this.first.next = slot;
    return this.target;
  },

  /**
   * Checks if the Signal contains a specific listener.
   * @param listener The listener to check for.
   * @return Whether or not the listener is in the queue for this signal.
   */
  has: function( listener )
  {
    if ( this.first === this.last ) return false;

    var node = this.first;
    do {
      if ( node.next && node.next.listener === listener ) {
        return true;
      }
    }
    while( node = node.next );

    return false;
  },

  /**
   * Gets the number of listeners.
   */
  getLength: function()
  {
    var count = 0;

    var node = this.first;
    while ( node = node.next ) {
      ++count;
    }

    return count;
  },

  /**
   * My mother told a listener once. Once.
   * @param listener The function to be called when the signal fires.
   * @param target The value of this in listeners when broadcasting only this listener.
   */
  once: function( listener, target )
  {
    var that = this;
    function oneTime() {
      that.remove( oneTime );
      listener.apply( this, arguments );
    }
    return this.add( oneTime, target );
  },

  /**
   * Remove a listener for this Signal.
   * @param listener The function to be removed from the signal.
   */
  remove: function( listener )
  {
    if (this.first === this.last ) return;

    var node = this.first;

    while ( node = node.next ) {
      if ( node.listener === listener ) {
        cutNode.call( this, node );
        break;
      }
    }

    if ( this.first === this.last )
      this.first.next = null;

    return this.target;
  },

  /**
   * Remove all listeners from this Signal.
   */
  removeAll: function()
  {
    this.first.next = null;
    this.first.prev = null;
    this.last = this.first;

    return this.target;
  },

  /**
   * Broadcast the signal. Allocates no memory during broadcast, and is lightening fast.
   */
  broadcast: function()
  {
    if ( this.first === this.last ) return;

    this.broadcasting = true;

    var node = this.first;

    while ( (node = node.next) && this.broadcasting )
    {
      var val = node.listener.apply(
        node.target || this.target, arguments
      );
      if ( this.eachReturn )
        this.eachReturn( val, arguments );
    }

    this.broadcasting = false;

    return this.target;
  },

  stopBroadcast: function() {
    this.broadcasting = false;
    return this.target;
  }
};

var _ns = null;

/**
 * A more fully featured Signal. Provides additional functionality with namespaces and priority adds.
 * @param target The value of this in listeners when broadcasting.
 * @param eachReturn A callback to handle the return value of each listener.
 */
function Signal( target, eachReturn )
{
  SignalLite.apply( this, arguments );

  var signal = this;
  this.ns = this.namespace = function( ns ) {
    return this[ ns ] || this.ns.register( ns );
  };
  this.ns.register = function( namespace )
  {
    // prevents overwriting of built in props.
    if ( signal[ namespace ] ) return;

    signal[ namespace ] = {
      add: function( listener, target )
      {
        signal.add( listener, target );
        signal.last.ns = namespace;
        return signal.target;
      },
      addToTop: function( listener, target )
      {
        signal.addToTop( listener, target );
        signal.first.next.ns = namespace;
        return signal.target;
      },
      remove: function( listener )
      {
        if ( !listener || signal.first === signal.last ) return;

        var node = signal.first;

        while ( node = node.next ) {
          if ( node.listener === listener &&
              node.ns === namespace ) {
            cutNode.call( signal, node );
            break;
          }
        }

        if ( signal.first === signal.last )
          signal.first.next = null;

        return signal.target;
      },
      removeAll: function()
      {
        if ( signal.first === signal.last ) return;

        var node = signal.first;

        while ( node = node.next )
          if ( node.ns === namespace )
            cutNode.call( signal, node );

        if ( signal.first === signal.last )
          signal.first.next = null;

        return signal.target;
      },
      once: function( listener, target )
      {
        signal.once( listener, target );
        signal.last.ns = namespace;

        return signal.target;
      },
      priority: function( priority ) {
        _ns = namespace;
        var p = signal.priority( priority );
        _ns = null;
        return p;
      }
    };
    return signal[ namespace ];
  };
  this.ns.unregister = function( namespace ) {
    // :TODO: find a nice way to protect built in props
    delete signal[ namespace ];
  };

  // need to override the original add methods to set default priority of 0.
  var zeroP = signal.priority( 0 );
  signal.add = zeroP.add;
  signal.addToTop = zeroP.addToTop;
  signal.once = zeroP.once;
}
Signal.prototype = new SignalLite();

/**
 * priority - adds an item with a specific priority.
 * @param priority A number representing the priority position to add the listener.
 * @return An object with the add methods - add, addToTop and once.
 */
Signal.prototype.priority = function( priority )
{
  function priorityAdd( listener, target, compare )
  {
    // if the listener is already linked, remove it to reinsert.
    if ( signal.has( listener ) )
      signal.remove( listener );

    // if there are no listeners, insert at the beginning.
    if ( signal.first === signal.last ) {
      parent.add.call( signal, listener, target );
      signal.last.priority = priority;
      return;
    }

    var node = signal.first;
    while ( node = node.next )
    {
      if ( compare( node.priority, priority ) )
      {
        var slot = new SlotLite( listener, target );
        slot.priority = priority;
        slot.next = node;
        slot.prev = node.prev;
        node.prev.next = slot;
        node.prev = slot;
        slot.ns = pns;
        return;
      }
    }

    // If we got here, priority puts it at the end of the list.
    parent.add.call( signal, listener, target );
    signal.last.priority = priority;
  }
  var signal = this, pns = _ns, parent = SignalLite.prototype,
  props = {
    add: function( listener, target )
    {
      priorityAdd( listener, target,
        function( p1, p2 ) {
          return p1 > p2;
        }
      );
      return signal.target;
    },
    addToTop: function( listener, target )
    {
      priorityAdd( listener, target,
        function( p1, p2 ) {
          return p1 >= p2;
        }
      );
      return signal.target;
    },
    once: function( listener, target )
    {
      var add = signal.add;
      signal.add = props.add;
      parent.once.call( signal, listener, target );
      signal.add = add;
      return signal.target;
    }
  };
  return props;
};

exports.SignalLite = SignalLite;
exports.SlotLite = SlotLite;
exports.Signal = Signal;

})( true ? exports : this);


/***/ }),
/* 11 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

!function(n,t){ true?t(exports,__webpack_require__(0)):"function"==typeof define&&define.amd?define(["exports","preact"],t):t((n=n||self).preactContext={},n.preact)}(this,function(n,t){"use strict";var i=function(n,t){return(i=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,t){n.__proto__=t}||function(n,t){for(var i in t)t.hasOwnProperty(i)&&(n[i]=t[i])})(n,t)};function r(n,t){function r(){this.constructor=n}i(n,t),n.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}var e={register:function(n){console.warn("Consumer used without a Provider")},unregister:function(n){},val:function(n){}};function u(n){var t=n.children;return{child:1===t.length?t[0]:null,children:t}}function o(n){return u(n).child||"render"in n&&n.render}var c=1073741823,f=function(){return c},s=0;function a(n,i){var a="_preactContextProvider-"+s++;return{Provider:function(n){function e(t){var r=n.call(this,t)||this;return r.t=function(n,t){var i=[],r=n,e=function(n){return 0|t(r,n)};return{register:function(n){i.push(n),n(r,e(r))},unregister:function(n){i=i.filter(function(t){return t!==n})},val:function(n){if(void 0===n||n==r)return r;var t=e(n);return r=n,i.forEach(function(i){return i(n,t)}),r}}}(t.value,i||f),r}return r(e,n),e.prototype.getChildContext=function(){var n;return(n={})[a]=this.t,n},e.prototype.componentDidUpdate=function(){this.t.val(this.props.value)},e.prototype.render=function(){var n=u(this.props),i=n.child,r=n.children;return i||t.h("span",null,r)},e}(t.Component),Consumer:function(t){function i(i,r){var e=t.call(this,i,r)||this;return e.i=function(n,t){var i=e.props.unstable_observedBits,r=void 0===i||null===i?c:i;0!=((r|=0)&t)&&e.setState({value:n})},e.state={value:e.u().val()||n},e}return r(i,t),i.prototype.componentDidMount=function(){this.u().register(this.i)},i.prototype.shouldComponentUpdate=function(n,t){return this.state.value!==t.value||o(this.props)!==o(n)},i.prototype.componentWillUnmount=function(){this.u().unregister(this.i)},i.prototype.componentDidUpdate=function(n,t,i){var r=i[a];r!==this.context[a]&&((r||e).unregister(this.i),this.componentDidMount())},i.prototype.render=function(){var n="render"in this.props&&this.props.render,t=o(this.props);if(n&&n!==t&&console.warn("Both children and a render function are defined. Children will be used"),"function"==typeof t)return t(this.state.value);console.warn("Consumer is expecting a function as one and only child but didn't find any")},i.prototype.u=function(){return this.context[a]||e},i}(t.Component)}}var h=a;n.default=a,n.createContext=h,Object.defineProperty(n,"__esModule",{value:!0})});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getFontUrl = getFontUrl;

var _preact = __webpack_require__(0);

var _actions = __webpack_require__(2);

var _actions2 = _interopRequireDefault(_actions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function getFontUrl(attrs) {
  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var args = [];
  for (var key in attrs) {
    args.push(key + '=' + encodeURIComponent(attrs[key]));
  }
  return '/fontgen/?' + args.join('&');
}

var FontImage = function (_Component) {
  _inherits(FontImage, _Component);

  function FontImage(props) {
    _classCallCheck(this, FontImage);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleResize = function (event) {
      _this.setState({
        pixelRatio: window.devicePixelRatio || 1
      });
    };

    _this.handleLoad = function (event) {
      _this.setState({ isLoading: false });
      if (_this.props.onLoad) {
        _this.props.onLoad(_this.state.src);
      }
    };

    _this.handleError = function (event) {
      _this.setState({ isLoading: false, isInError: true });
      if (_this.props.onLoadError) {
        _this.props.onLoadError(_this.state.src);
      }
    };

    _this.handleRef = function (image) {
      _this.image = image;
    };

    _this.isComplete = function () {
      return _this.image.complete;
    };

    _this.state = { pixelRatio: window.devicePixelRatio || 1 };
    _this.state.src = _this.makeSrc(props);
    _this.state.isLoading = true;
    _this.state.isInError = false;
    return _this;
  }

  FontImage.prototype.makeSrc = function makeSrc(props) {
    var state = this.state;

    return getFontUrl({
      pid: props.id,
      ps: props.pointSize,
      wi: props.width,
      hi: props.height,
      bc: props.backgroundColor,
      fc: props.foregroundColor,
      bco: props.backgroundOpacity,
      pt: props.paddingTop,
      pl: props.paddingLeft,
      rm: props.pixelRatio === 'auto' ? state.pixelRatio : props.pixelRatio,
      t: props.text
    }, props.cache);
  };

  FontImage.prototype.componentWillMount = function componentWillMount() {
    window.addEventListener('resize', this.handleResize);
  };

  FontImage.prototype.componentDidMount = function componentDidMount() {
    var props = this.props,
        state = this.state,
        image = this.image;

    if (image && image.complete) {
      if (state.isLoading) {
        this.setState({ isLoading: false });
      }
    } else if (props.onLoadStart) {
      props.onLoadStart(state.src);
    }
  };

  FontImage.prototype.componentWillUnmount = function componentWillUnmount() {
    var props = this.props,
        state = this.state;

    if (state.isLoading && props.onLoadAbort) {
      props.onLoadAbort(state.src);
    }
  };

  FontImage.prototype.componentWillReceiveProps = function componentWillReceiveProps(newProps) {
    var src = this.makeSrc(newProps);
    if (src !== this.state.src) {
      if (this.state.isLoading && this.props.onLoadAbort) {
        this.props.onLoadAbort(this.state.src);
      }
      this.setState({
        isLoading: true,
        isInError: false,
        src: src
      });
      if (this.props.onLoadStart) {
        this.props.onLoadStart(src);
      }
    }
  };

  FontImage.prototype.render = function render() {
    var props = this.props,
        state = this.state;

    return (0, _preact.h)('img', { className: 'font-preview', width: props.width, height: props.height,
      onLoad: this.handleLoad, onError: this.handleError, style: { opacity: state.isLoading ? .1 : 1 },
      alt: props.text, src: state.src, ref: this.handleRef });
  };

  return FontImage;
}(_preact.Component);

FontImage.defaultProps = {
  width: 864,
  height: 160,
  pointSize: 72,
  backgroundColor: 'ffffff',
  foregroundColor: '000000',
  backgroundOpacity: '0',
  paddingTop: 0,
  paddingLeft: 0,
  cache: true,
  pixelRatio: 'auto',
  text: 'Terminal Design'
};
exports.default = FontImage;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _preact = __webpack_require__(0);

var _FontMenu = __webpack_require__(16);

var _FontMenu2 = _interopRequireDefault(_FontMenu);

var _FontList = __webpack_require__(17);

var _FontList2 = _interopRequireDefault(_FontList);

var _actions = __webpack_require__(2);

var _BuyingOptions = __webpack_require__(29);

var _BuyingOptions2 = _interopRequireDefault(_BuyingOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// wp_enqueue_script: jquery

// wp_enqueue_script: underscore
var $ = jQuery; /* global products jQuery */


var supportsPassive = false;
try {
  var opts = Object.defineProperty({}, 'passive', { get: function get() {
      supportsPassive = true;
    } });
  window.addEventListener("testPassive", null, opts);
  window.removeEventListener("testPassive", null, opts);
} catch (e) {}

function passive() {
  return supportsPassive ? { passive: true } : false;
}

// render font menu
(0, _preact.render)((0, _preact.h)(_FontMenu2.default, null), document.getElementById('fonts-menu'));

// render the font list
(0, _preact.render)((0, _preact.h)(_FontList2.default, null), document.getElementById('font-list'));

_actions.FontPageStore.listVisibilityChanged.add(function (visible) {
  if (visible) {
    $('#content.container').hide();
    $('#secondary-header .font-types').show().css('visibility', 'visible');
    if (_actions.FontPageStore.activeFilter === 'all') {
      $('#secondary-header .font-types a[data-font-filter="all"]').addClass('active');
    }
    if (!/^\/fonts\/?$/.test(window.location.pathname)) {
      $(document.body).removeClass('home');
      window.history.pushState({}, 'Fonts - Terminal Design', '/fonts');
      $('#secondary-header .buying-menu').hide();
      $('#secondary-header .buying-menu.fonts-page-menu').show();
    }
  } else {
    $('#content.container').show();
    $('#secondary-header .font-types').hide();
    $('#secondary-header .buying-menu').show();
    $('#secondary-header .buying-menu.fonts-page-menu').hide();
    if (window.location.pathname === '/') {
      $(document.body).addClass('home open-menu');
    }
  }
});
// Add the history back button event handler to re-hide the font-list, and show the content
window.onpopstate = function (event) {
  if (!/^\/(fonts|collections)\/?$/.test(window.location.pathname)) {
    _actions.FontPageActions.makeListHidden();
  } else {
    _actions.FontPageActions.makeListVisible();
  }
};
if (/^\/(fonts|collections)\/?$/.test(window.location.pathname)) {
  $('#content.container').hide();
}

// wire up the font list filter buttons
$('.showall-fonts a').click(function (event) {
  event.preventDefault();
  _actions.FontPageActions.filterByClassification('all');
  closeMega(true);
});
$('.showselected-fonts a').click(function (event) {
  event.preventDefault();
  if (!/^\/fonts\/?$/.test(window.location.pathname)) {
    _actions.FontPageActions.filterByClassification('all');
  }
  closeMega(true);
});

var closingMegaID;
function closeMega(closeMainAfter) {
  clearTimeout(closingMegaID);
  if ($('body').hasClass('mega-active')) {
    $('a.active', '#navbar').removeClass('active');
    $('body').removeClass('mega-active');
    if (closeMainAfter && !$(document.body).hasClass('home')) {
      closingMegaID = setTimeout(closeMain, 500);
    }
  } else if (closeMainAfter && !$(document.body).hasClass('home')) {
    closeMain();
  }
}
var closingID = null;
var isOpening = null;
function closeMain() {
  $('body').removeClass('open-menu')[0].isClosing = true;
  clearTimeout(closingID);
  clearTimeout(isOpening);
  isOpening = null;
  if (!$(document.body).hasClass('home') && document.documentElement.scrollTop < 86) {
    $(document.documentElement).animate({
      scrollTop: 86
    }, 300);
  }
  closingID = setTimeout(function () {
    $('body').removeClass('open-menu')[0].isClosing = false;
  }, 500);
}
function openMain() {
  clearTimeout(closingID);
  clearTimeout(closingMegaID);
  isOpening = setTimeout(function () {
    isOpening = null;
  }, 500);
  $('body').addClass('open-menu');
}

$('.close-mega').click(function (e) {
  e.preventDefault();
  closeMega(true);
});

function openSubMenuContent($evt) {
  clearTimeout(closingID);
  clearTimeout(closingMegaID);
  $evt.preventDefault();
  $evt.stopPropagation();
  var $this = $(this);
  var $menus = $('.mega-menu');
  var $oldActive = $('a.active', '#navbar');

  if ($this.parent().hasClass('fonts')) {
    $('.fonts-mega').show();
    $('.client-work-mega').hide();
    $('.about-mega').hide();
    $('.fonts-submenu').show();
    $('.client-work-submenu').hide();
    $('.about-submenu').hide();
  } else if ($this.parent().hasClass('client')) {
    $oldActive.off('mouseover');
    $('.fonts-mega').hide();
    $('.client-work-mega').show();
    $('.about-mega').hide();
    $('.fonts-submenu').hide();
    $('.client-work-submenu').show();
    $('.about-submenu').hide();
  } else if ($this.parent().hasClass('about')) {
    $oldActive.off('mouseover');
    $('.fonts-mega').hide();
    $('.client-work-mega').hide();
    $('.about-mega').show();
    $('.fonts-submenu').hide();
    $('.client-work-submenu').hide();
    $('.about-submenu').show();
  }

  if (isOpening) return;

  $oldActive.removeClass('active');
  $menus.removeClass('active');
  $('body').addClass('mega-active');
  $this.addClass('active');
  $('#fonts-menu-mega').addClass('active');
}
var fontsMenuOverID;
$('#navbar .fonts a').on('mouseover', function ($evt) {
  $evt.preventDefault();
  $evt.stopPropagation();
  var self = this;
  fontsMenuOverID = setTimeout(function () {
    if ($('body').hasClass('open-menu')) {
      openSubMenuContent.call(self, $evt);
    }
  }, 400);
}).on('mouseout', function () {
  clearTimeout(fontsMenuOverID);
}).on('click', function ($event) {
  $event.preventDefault();
});
// $('#navbar .client a, #navbar .about a').on('click', function ($evt) {
//   $(this).on('mouseover', $evt => $evt.stopPropagation())
//   openSubMenuContent.call(this, $evt)
// })
$('#main-header').on('mouseover', function ($evt) {
  return closeMega();
});

function openOnScroll() {
  var isOpen = $('body').hasClass('open-menu');
  if (!isOpen) {
    openMain();
  }
}
function closeOnScroll() {
  // scrolling down the page
  if ($('body').hasClass('home')) return;
  var isOpen = $('body').hasClass('open-menu');
  var isMegaActive = $('body').hasClass('mega-active');
  if (isOpen && !isMegaActive) {
    if ($('body').removeClass('open-menu')[0].isClosing) {
      closeMega(true);
    }
  }
}

var lastPos = 0;
function handleScroll() {
  var $doc = $(document);
  var scrollTop = $doc.scrollTop();
  if (lastPos > scrollTop) {
    openOnScroll();
  } else {
    closeOnScroll();
  }
  lastPos = scrollTop;
}
window.addEventListener('scroll', handleScroll, passive());
function handleWheel(event) {
  if (event.wheelDelta > 0) {
    // scrolling up
    openOnScroll();
  } else if (event.wheelDelta < 0) {
    // scrolling down the page
    closeOnScroll();
  }
}
var body = $('body')[0];
body.addEventListener('mousewheel', handleWheel, passive());
body.addEventListener('wheel', handleWheel, passive());

var _sampleTextInputTID = 0;
$('#font-detail .text-source input').on('change input', function ($event) {
  clearTimeout(_sampleTextInputTID);
  _sampleTextInputTID = setTimeout(function () {
    _actions.FontPageActions.updateAllSampleText($event.target.value);
    if (window.updateTesterImage) {
      window.updateTesterImage($event.target.value);
    }
  }, 250);
});

$('.close-main a').click(function (e) {
  e.preventDefault();
  if ($('body').hasClass('open-menu')) {
    $('body')[0].isClosing = true;
    closeMega(true);
  } else {
    openMain();
  }
});
var openWaitingID = false;
$('#secondary-header').on('mousemove', function ($event) {
  if (!$('body').hasClass('open-menu') && !$('body')[0].isClosing && $event.pageY - $(this).offset().top <= 12) {
    if (openWaitingID) return;
    openWaitingID = setTimeout(function () {
      openWaitingID = false;
      openMain();
    }, 400);
  } else {
    if (openWaitingID) {
      clearTimeout(openWaitingID);
      openWaitingID = false;
    }
  }
});

// Util
// function deparam (p) {
//   const ret = {}
//   const seg = p.replace(/^\?/, '').split('&')
//   for (let i = 0, n = seg.length; i < n; i++) {
//     if (!seg[i]) continue
//     let s = seg[i].split('=', 1)
//     ret[s[0]] = s[1]
//   }
//   return ret
// }

// function checkCartItems (data) {
//   $('.cart-item-count').remove()
//   if ( data.length )
//     $('#main-cart-button').before('<span class="cart-item-count">'+data.length+'</span>')

//   // $('a[href*="/cart/?add="]').each(function( index, element ){
//   //   var add = parseInt( deparam( element.search ).add )
//   //   if ( jQuery.inArray( add, data ) + 1 )
//   //     $(element).addClass('item-in-cart').text('In Cart')
//   //   else
//   //     $(element).removeClass('item-in-cart').text('Add to Cart')
//   // })

//   if ( $('#cart .cart-table').length ) {
//     $('#cart .cart-table .row').each(function( index, element ) {
//       var remove = true, that = $(element)
//       data.forEach(function(entry){
//         if ( that.hasClass( 'item-row-' + entry ) )
//           remove = false
//       })
//       if ( remove )
//         $(this).remove()
//     })
//   }
// }

// Get cart items. Init.
// $.post( cart_url+'?ajax_get', function( data ) {
//   checkCartItems( data )
// })

// support retina and HiDPI
// $('.font-image').each(function () {
//   var $this = $(this)
//   var src = $this.attr('src')

//   // check for data-src
//   if (src === '#') src = $this.data('src')

//   // if we don't have an src, just abort.
//   if (!src) return

//   // add the resize multiplier
//   if (src.indexOf('rm=') === -1) {
//     src += '&rm=' + (window.devicePixelRatio || 1)
//   }

//   $this.attr('src', src)
// })

$('#secondary-header .font-types [data-font-filter]').click(function (e) {
  e.preventDefault();
  var $this = $(this);
  var filter = $this.data('font-filter');

  _actions.FontPageActions.filterByClassification(filter);
});
_actions.FontPageStore.listFilterChanged.add(function (filter) {
  $('#secondary-header .font-types [data-font-filter]').each(function (i) {
    var $this = $(this);
    if ($this.data('font-filter') === filter) {
      $this.addClass('active');
    } else {
      $this.removeClass('active');
    }
  });
});
// assume all is the default
// $('#secondary-header .font-types [data-font-filter=all]').addClass("active")

// mount the buying options modal
function displayFont(fontID) {
  var product = products[fontID];
  (0, _BuyingOptions.invokeBuyingOptions)(product);
}

// invoke the modal
$('.add-to-cart-button').on('click', function ($evt) {
  $evt.preventDefault();
  displayFont($(this).data('product-id'));
});
(0, _preact.render)((0, _preact.h)(_BuyingOptions2.default, null), document.getElementById('modal-container'));

if (/^\/fonts\/?$/.test(window.location.pathname)) {
  _actions.FontPageActions.filterByClassification('all');
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.FontMenuItem = undefined;

var _preact = __webpack_require__(0);

var _actions = __webpack_require__(2);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FontMenu = function (_Component) {
  _inherits(FontMenu, _Component);

  function FontMenu() {
    var _temp, _this, _ret;

    _classCallCheck(this, FontMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      fullFontList: _actions.FontPageStore.getFullFontList(),
      filteredFontList: _actions.FontPageStore.getFilteredFontList(),
      activeFilter: _actions.FontPageStore.getListFilter()
    }, _this.handleFullFontListChanged = function (fullFontList) {
      // grab the array of models out of backbone collection
      _this.setState({
        fullFontList: fullFontList
      });
    }, _this.handleFilteredFontListChanged = function (filteredFontList) {
      _this.setState({
        filteredFontList: filteredFontList
      });
    }, _this.handleFilterChanged = function (activeFilter) {
      _this.setState({ activeFilter: activeFilter });
    }, _this.handleChecked = function (menuItem) {
      // If activeFilter is "all" then we'll only have one checkbox after this.
      if ("all" == _this.state.activeFilter) {
        _actions.FontPageActions.setFilteredModels([menuItem.model]);
      } else {
        _actions.FontPageActions.addModelToPage(menuItem.model);
      }
    }, _this.handleUnchecked = function (menuItem) {
      _actions.FontPageActions.removeModelFromPage(menuItem.model);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  FontMenu.prototype.componentDidMount = function componentDidMount() {
    // wire up the store signals
    _actions.FontPageStore.fullFontListChanged.add(this.handleFullFontListChanged, this);
    _actions.FontPageStore.filteredFontListChanged.add(this.handleFilteredFontListChanged, this);
    _actions.FontPageStore.listFilterChanged.add(this.handleFilterChanged, this);
  };

  FontMenu.prototype.componentWillUnmount = function componentWillUnmount() {
    // destroy!
    _actions.FontPageStore.fullFontListChanged.remove(this.handleFullFontListChanged);
    _actions.FontPageStore.filteredFontListChanged.remove(this.handleFilteredFontListChanged);
    _actions.FontPageStore.listFilterChanged.remove(this.handleFilterChanged);
  };

  FontMenu.prototype.render = function render() {
    var _this2 = this;

    var filteredList = this.state.filteredFontList;
    var fullList = this.state.fullFontList;
    // if the filtered list is 'all', we show no checkboxes
    var fontMenuItems = fullList.map(function (model) {
      var isChecked = 'all' !== _this2.state.activeFilter && filteredList.find(function (filteredModel) {
        return model.attributes.id === filteredModel.attributes.id;
      });
      return (0, _preact.h)(FontMenuItem, { model: model,
        onChecked: _this2.handleChecked, onUnchecked: _this2.handleUnchecked,
        checked: isChecked, key: 'fm-' + model.attributes.id });
    });

    return (0, _preact.h)(
      'div',
      { className: 'columns' },
      fontMenuItems
    );
  };

  return FontMenu;
}(_preact.Component);

exports.default = FontMenu;

var FontMenuItem = exports.FontMenuItem = function (_Component2) {
  _inherits(FontMenuItem, _Component2);

  function FontMenuItem(props) {
    _classCallCheck(this, FontMenuItem);

    var _this3 = _possibleConstructorReturn(this, _Component2.call(this, props));

    _this3.handleCheckboxToggle = function (event) {
      _this3.setState({
        checked: event.target.checked
      });
      if (event.target.checked) {
        _this3.props.onChecked(_this3);
      } else {
        _this3.props.onUnchecked(_this3);
      }
    };

    _this3.handleLinkClick = function (event) {
      event.preventDefault();
      var _checkbox = _this3._checkbox;

      _checkbox.checked = !_checkbox.checked;
      // annoying...
      if ("createEvent" in document) {
        var evt = document.createEvent('HTMLEvents');
        evt.initEvent('change', false, true);
        _checkbox.dispatchEvent(evt);
      } else if (_checkbox.fireEvent) {
        _checkbox.fireEvent('onchange');
      }
    };

    _this3.handleCheckboxRef = function (target) {
      _this3._checkbox = target;
    };

    _this3.model = props.model;
    // set the initial state from props
    _this3.state = {
      _item: _.clone(_this3.model.attributes),
      checked: _this3.props.checked
    };
    return _this3;
  }

  FontMenuItem.prototype.componentDidMount = function componentDidMount() {
    // wire up the backbone change events
    this.model.on('change', function (model) {
      this.setState({ _item: _.clone(model.attributes) });
    });
  };

  FontMenuItem.prototype.componentWillUnmount = function componentWillUnmount() {
    this.model.off('change');
  };

  FontMenuItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.checked !== this.props.checked) {
      this.setState({ checked: nextProps.checked });
    }
  };

  FontMenuItem.prototype.render = function render() {
    var atts = this.state._item;
    var imageSrc = atts.acf.menu_image_url ? 'url("' + atts.acf.menu_image_url + '")' : 'url("/fontgen?pid=' + atts.acf.default_display_download + '&t=' + atts.title.rendered + '&ps=20&fc=000000&bco=0&wi=276&hi=32&pt=7&pl=41")';
    return (0, _preact.h)(
      'div',
      { id: 'family-' + atts.id, className: 'font-item' },
      (0, _preact.h)(
        'label',
        null,
        (0, _preact.h)('input', { ref: this.handleCheckboxRef, checked: this.state.checked, type: 'checkbox', onChange: this.handleCheckboxToggle }),
        (0, _preact.h)('span', { className: 'check' })
      ),
      (0, _preact.h)(
        'a',
        { style: {
            backgroundImage: imageSrc
          }, href: atts.link, onClick: this.handleLinkClick },
        atts.title.rendered
      )
    );
  };

  return FontMenuItem;
}(_preact.Component);

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__(0);

var _reactMotion = __webpack_require__(18);

var _actions = __webpack_require__(2);

var _FontImage = __webpack_require__(14);

var _FontImage2 = _interopRequireDefault(_FontImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FontList = function (_Component) {
  _inherits(FontList, _Component);

  function FontList(props) {
    _classCallCheck(this, FontList);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.updateAllSampleText = function (sampleText) {
      _this.setState({
        sampleText: sampleText || _this.defaultSampleText
      });
    };

    _this.textInputThrottleID = 0;

    _this.handleSampleTextChange = function (event) {
      // capture target - it gets cleared by React before the timeout
      var target = event.target;

      clearTimeout(_this.textInputThrottleID);
      _this.textInputThrottleID = setTimeout(function () {
        _actions.FontPageActions.updateAllSampleText(target.value);
        if (window.updateTesterImage) {
          window.updateTesterImage(target.value);
        }
      }, 250);
    };

    _this.handleLoadStart = function (url) {
      var itemsLoaded = _this.state.itemsLoaded;

      if (itemsLoaded.indexOf(url) < 0) {
        itemsLoaded.push(url);
      }
      // console.log('handleLoadStart', itemsLoaded.length)
      _this.setState({ itemsLoaded: itemsLoaded, isLoading: itemsLoaded.length > 0 });
    };

    _this.handleLoad = function (url) {
      var itemsLoaded = _this.state.itemsLoaded;

      var position = itemsLoaded.indexOf(url);
      if (position > -1) {
        itemsLoaded.splice(position, 1);
      }
      // console.log('handleLoadComplete', itemsLoaded.length)
      _this.setState({ itemsLoaded: itemsLoaded, isLoading: itemsLoaded.length > 0 });
    };

    _this.getDefaultMotionValue = function () {
      var items = _this.state.items;

      var configs = items.map(function (model, i) {
        return {
          style: {
            height: (0, _reactMotion.spring)(0, _reactMotion.presets.stiff),
            opacity: (0, _reactMotion.spring)(1, _reactMotion.presets.stiff),
            marginBottom: (0, _reactMotion.spring)(0, _reactMotion.presets.stiff)
          },
          data: model,
          key: _this.getConfigKey(model)
        };
      });
      return configs;
    };

    _this.getEndValue = function () {
      var items = _this.state.items;

      var configs = items.map(function (model, i) {
        return {
          style: {
            height: (0, _reactMotion.spring)(160, _reactMotion.presets.stiff),
            opacity: (0, _reactMotion.spring)(1, _reactMotion.presets.stiff),
            marginBottom: (0, _reactMotion.spring)(10, _reactMotion.presets.stiff)
          },
          data: model,
          key: _this.getConfigKey(model)
        };
      });
      return configs;
    };

    _this.willEnter = function () {
      return {
        height: 0,
        opacity: 0,
        marginBottom: 0
      };
    };

    _this.willLeave = function () {
      return {
        height: (0, _reactMotion.spring)(0),
        opacity: (0, _reactMotion.spring)(0),
        marginBottom: (0, _reactMotion.spring)(0)
      };
    };

    _this.defaultSampleText = 'Whaddayagonnado?';
    _this.state = {
      items: _actions.FontPageStore.getFilteredFontList(),
      itemsLoaded: [],
      sampleText: _this.defaultSampleText,
      visible: _actions.FontPageStore.getListVisibility(),
      isLoading: false
    };
    return _this;
  }

  FontList.prototype.componentDidMount = function componentDidMount() {
    _actions.FontPageStore.allSampleTextChanged.add(this.updateAllSampleText, this);
    _actions.FontPageStore.filteredFontListChanged.add(this.handleFilteredFontListChanged, this);
    _actions.FontPageStore.listVisibilityChanged.add(this.handleVisibilityChanged, this);
  };

  FontList.prototype.componentWillUnmount = function componentWillUnmount() {
    _actions.FontPageStore.allSampleTextChanged.remove(this.updateAllSampleText, this);
    _actions.FontPageStore.filteredFontListChanged.remove(this.handleFilteredFontListChanged, this);
    _actions.FontPageStore.listVisibilityChanged.remove(this.handleVisibilityChanged, this);
  };

  FontList.prototype.handleFilteredFontListChanged = function handleFilteredFontListChanged(filteredFontList) {
    this.setState({
      items: filteredFontList
    });
  };

  FontList.prototype.handleVisibilityChanged = function handleVisibilityChanged(visible) {
    this.setState({
      visible: visible
    });
  };

  FontList.prototype.render = function render() {
    var _this2 = this;

    if (!this.state.visible) {
      return null;
    }
    return (0, _preact.h)(
      'div',
      null,
      (0, _preact.h)(
        'div',
        { className: 'row preview-input' },
        (0, _preact.h)(
          'div',
          { className: 'span-3 spinner' },
          this.state.isLoading && (0, _preact.h)('img', { src: '/wp-content/themes/terminal-design-5/images/ajax-loader.gif' })
        ),
        (0, _preact.h)(
          'div',
          { className: 'span-9 text-source' },
          (0, _preact.h)('input', { type: 'text', onInput: this.handleSampleTextChange,
            onChange: this.handleSampleTextChange, placeholder: 'Change the text here\u2026' })
        )
      ),
      (0, _preact.h)(
        _reactMotion.TransitionMotion,
        {
          defaultStyles: this.getDefaultMotionValue(),
          styles: this.getEndValue(),
          willLeave: this.willLeave,
          willEnter: this.willEnter },
        function (interpolatedStyles) {
          return (0, _preact.h)(
            'div',
            null,
            interpolatedStyles.map(function (config) {
              var style = config.style,
                  key = config.key;

              var model = config.data;
              return (0, _preact.h)(FontBox, { style: style,
                onLoad: _this2.handleLoad, onLoadAbort: _this2.handleLoad, onLoadError: _this2.handleLoad, onLoadStart: _this2.handleLoadStart,
                sampleText: _this2.state.sampleText,
                defaultSampleText: _this2.defaultSampleText,
                model: model, key: 'fb-' + key });
            })
          );
        }
      )
    );
  };

  FontList.prototype.componentDidUpdate = function componentDidUpdate() {
    // :HACK: Hides the extra space above the content when the main menu is closed
    if (this.state.visible && document.documentElement.scrollTop < 86) {
      document.documentElement.scrollTop = 86;
    }
  };

  // actual animation-related logic


  FontList.prototype.getConfigKey = function getConfigKey(model) {
    return 'k-' + model.attributes.id;
  };

  return FontList;
}(_preact.Component);

FontList.defaultProps = {
  visible: false
};
exports.default = FontList;

var FontBox = function (_Component2) {
  _inherits(FontBox, _Component2);

  function FontBox() {
    var _temp, _this3, _ret;

    _classCallCheck(this, FontBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this3 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this3), _this3.state = {
      sampleText: '',
      sampleFont: '',
      pixelRatio: _actions.FontPageStore.getPixelRatio()
    }, _this3._sampleTextInputTID = 0, _this3.handleSampleTextChange = function (event) {
      // capture target - target will be cleared from the event object before the timeout
      var target = event.target;

      // use a timeout to avoid hammering the render server

      clearTimeout(_this3._sampleTextInputTID);
      _this3._sampleTextInputTID = setTimeout(function () {
        _this3.setState({
          sampleText: target.value
        });
      }, 250);
    }, _this3.handleSampleFontChange = function (event) {
      var target = event.target;
      _this3.setState({
        sampleFont: target.value
      });
    }, _temp), _possibleConstructorReturn(_this3, _ret);
  }

  FontBox.prototype.componentDidMount = function componentDidMount() {
    _actions.FontPageStore.pixelRatioChanged.add(this.handlePixelRatioChange, this);
  };

  FontBox.prototype.componentWillUnmount = function componentWillUnmount() {
    _actions.FontPageStore.pixelRatioChanged.remove(this.handlePixelRatioChange);
  };

  FontBox.prototype.handlePixelRatioChange = function handlePixelRatioChange(event) {
    this.setState({
      pixelRatio: _actions.FontPageStore.getPixelRatio()
    });
  };

  FontBox.prototype.render = function render() {
    var model = this.props.model;
    var acf = model.attributes.acf;
    var children = acf.font_family && acf.font_family.acf && acf.font_family.acf.children;
    var defaultDisplayCode = acf && acf.default_display_download;
    var selectedDisplayCode = this.state.sampleFont || defaultDisplayCode;
    var sampleText = this.state.sampleText || this.props.sampleText;
    return (0, _preact.h)(
      'div',
      { className: 'row font-box', style: this.props.style },
      (0, _preact.h)(
        'div',
        { className: 'span-3 left' },
        (0, _preact.h)(
          'div',
          { className: 'info' },
          (0, _preact.h)('h3', { dangerouslySetInnerHTML: { __html: model.attributes.title.rendered } }),
          (0, _preact.h)(
            'span',
            null,
            children && children.length > 1 ? children.length + ' fonts' : '1 font'
          ),
          (0, _preact.h)(
            'a',
            { href: '/fonts/' + model.attributes.slug + '/' },
            'View Family'
          ),
          (0, _preact.h)(
            'div',
            { 'class': 'collection-link' },
            acf.collection_link ? (0, _preact.h)(
              'a',
              { href: acf.collection_link },
              'View Collection'
            ) : ' '
          )
        ),
        (0, _preact.h)(
          'div',
          { className: 'sample-controls' },
          (0, _preact.h)(
            'select',
            { value: selectedDisplayCode, onChange: this.handleSampleFontChange },
            children && children.map(function (child) {
              return (0, _preact.h)(
                'option',
                { key: child.ID, value: child.ID },
                child.post_title
              );
            })
          ),
          (0, _preact.h)('input', { type: 'text', placeholder: 'Just change this text here...',
            onInput: this.handleSampleTextChange, onChange: this.handleSampleTextChange })
        )
      ),
      (0, _preact.h)(
        'div',
        { className: 'span-9 font-image-center' },
        (0, _preact.h)(
          'a',
          { href: '/fonts/' + model.attributes.slug + '/' },
          selectedDisplayCode && (0, _preact.h)(_FontImage2.default, { id: selectedDisplayCode, onLoadStart: this.props.onLoadStart,
            onLoad: this.props.onLoad, onLoadAbort: this.props.onLoadAbort, onLoadError: this.props.onLoadError,
            text: sampleText, width: '864', height: '160', pointSize: '72',
            paddingTop: '52', paddingLeft: '30', cache: this.props.defaultSampleText === sampleText,
            backgroundColor: 'ffffff', foregroundColor: '000000', backgroundOpacity: '0'
          })
        )
      )
    );
  };

  return FontBox;
}(_preact.Component);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(19);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(24);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(25);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(27);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(13);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(3);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(28);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(4);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(3);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(5);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(6);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(7);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(8);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 20 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(23);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(4);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(3);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(5);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(6);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(7);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(8);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(4);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(3);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(5);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(26);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(6);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(7);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(8);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(9);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(13);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.invokeBuyingOptions = invokeBuyingOptions;
exports.closeBuyingOptions = closeBuyingOptions;

var _preact = __webpack_require__(0);

var _signalsLite = __webpack_require__(10);

var _FontImage = __webpack_require__(14);

var _FontImage2 = _interopRequireDefault(_FontImage);

var _loadScript = __webpack_require__(30);

var _loadScript2 = _interopRequireDefault(_loadScript);

var _classnames = __webpack_require__(31);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// wp_enqueue_script: jquery


// global: products

function invokeBuyingOptions(product) {
  modalInvoked.broadcast(product);
}
function closeBuyingOptions() {
  modalDismissed.broadcast();
}

var modalInvoked = new _signalsLite.SignalLite();
var modalDismissed = new _signalsLite.SignalLite();

var BuyingOptions = function (_Component) {
  _inherits(BuyingOptions, _Component);

  function BuyingOptions() {
    var _temp, _this, _ret;

    _classCallCheck(this, BuyingOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
      visible: false,
      font: null,
      displayFontID: null,
      selectedDesktopLicense: '',
      selectedWebfontLicense: '',
      selectedAppLicense: '',
      selectedEpubLicense: '',
      addToCartDisabled: false,
      addToCartUIDisabled: false
    }, _this.disableAddToCart = function () {
      var timeoutID = setTimeout(function () {
        _this.setState({ addToCartUIDisabled: true });
      }, 250);
      _this.setState({ addToCartDisabled: timeoutID });
    }, _this.enableAddToCart = function () {
      clearTimeout(_this.state.addToCartDisabled);
      _this.setState({
        addToCartDisabled: false,
        addToCartUIDisabled: false
      });
    }, _this.handleInvoked = function (font) {
      var displayFontID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      _this.setState({
        font: font,
        displayFontID: displayFontID,
        visible: true,
        selectedDesktopLicense: '',
        selectedWebfontLicense: '',
        selectedAppLicense: '',
        selectedEpubLicense: '',
        selectedMultisiteLicense: '',
        addToCartDisabled: false,
        addToCartUIDisabled: false
      });
    }, _this.handleDismissed = function () {
      _this.setState({
        visible: false
      });
    }, _this.handleBoxClick = function (event) {
      event.stopPropagation();
    }, _this.handleCloseClick = function (event) {
      closeBuyingOptions();
    }, _this.handleDesktopChange = function (event) {
      _this.setState({ selectedDesktopLicense: event.target.value });
    }, _this.handleWebfontChange = function (event) {
      _this.setState({ selectedWebfontLicense: event.target.value });
    }, _this.handleAppChange = function (event) {
      _this.setState({ selectedAppLicense: event.target.value });
    }, _this.handleEpubChange = function (event) {
      _this.setState({ selectedEpubLicense: event.target.value });
    }, _this.handleMultisiteChange = function (event) {
      _this.setState({ selectedMultisiteLicense: event.target.value });
    }, _this.handleAddToCartClick = function (event) {
      event.preventDefault();
      if (_this.state.addToCartDisabled) return;
      if (!_this.state.font) return;

      var _this$state = _this.state,
          selectedDesktopLicense = _this$state.selectedDesktopLicense,
          selectedWebfontLicense = _this$state.selectedWebfontLicense,
          selectedEpubLicense = _this$state.selectedEpubLicense,
          selectedAppLicense = _this$state.selectedAppLicense,
          selectedMultisiteLicense = _this$state.selectedMultisiteLicense;

      if (!(selectedDesktopLicense || selectedWebfontLicense || selectedEpubLicense || selectedAppLicense || selectedMultisiteLicense)) return;

      // don't allow a second submit
      _this.disableAddToCart();

      var post = _this.state.font.post;
      var queue = [];
      if (selectedDesktopLicense) {
        queue.push(getAddToCartData(post.ID, selectedDesktopLicense, products[post.ID].nonce));
      }
      for (var id in products) {
        var product = products[id];
        var slug = products[id].post.post_name;
        if (selectedWebfontLicense && slug.indexOf(post.post_name + '-webfont') === 0) {
          queue.push(getAddToCartData(id, selectedWebfontLicense, products[id].nonce));
        }
        if (selectedAppLicense && slug.indexOf(post.post_name + '-apps') === 0) {
          queue.push(getAddToCartData(id, selectedAppLicense, products[id].nonce));
        }
        if (selectedEpubLicense && slug.indexOf(post.post_name + '-epubs') === 0) {
          queue.push(getAddToCartData(id, selectedEpubLicense, products[id].nonce));
        }
        if (selectedMultisiteLicense && slug.indexOf(post.post_name + '-multi-site') === 0) {
          queue.push(getAddToCartData(id, selectedMultisiteLicense, products[id].nonce));
        }
      }
      var i = 0;
      var loopReq = function loopReq() {
        i++;
        if (i < queue.length) {
          doCartRequest(queue[i], loopReq);
        } else {
          // this.enableAddToCart()
          window.location = '/cart';
        }
      };
      doCartRequest(queue[i], loopReq);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  BuyingOptions.prototype.componentDidMount = function componentDidMount() {
    modalInvoked.add(this.handleInvoked);
    modalDismissed.add(this.handleDismissed);
  };

  BuyingOptions.prototype.componentWillUnmount = function componentWillUnmount() {
    modalInvoked.remove(this.handleInvoked);
    modalDismissed.remove(this.handleDismissed);
  };

  BuyingOptions.prototype.render = function render() {
    var font = this.state.font;
    var post = font && font.post;
    var prices = font && font.prices;
    var priceOptions = [(0, _preact.h)(
      'option',
      { value: '' },
      'Select'
    )];
    var app,
        appPrices,
        appPriceOptions = [(0, _preact.h)(
      'option',
      { value: '' },
      'Select'
    )];
    var epub,
        epubPrices,
        epubPriceOptions = [(0, _preact.h)(
      'option',
      { value: '' },
      'Select'
    )];
    var webfont,
        webfontPrices,
        webfontPriceOptions = [(0, _preact.h)(
      'option',
      { value: '' },
      'Select'
    )];
    var multisite,
        multisitePrices,
        multisitePriceOptions = [(0, _preact.h)(
      'option',
      { value: '' },
      'Select'
    )];

    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });

    if (prices) {
      for (var key in prices) {
        var price = prices[key];
        priceOptions.push((0, _preact.h)(
          'option',
          { key: key, value: key },
          price.name + ' - ' + formatter.format(price.amount)
        ));
      }
    }

    if (post && products) {
      for (var id in products) {
        var product = products[id];
        var slug = products[id].post.post_name;
        if (slug.indexOf(post.post_name + '-apps') === 0) {
          app = product.post;
          appPrices = product.prices;
          for (var _key2 in appPrices) {
            var _price = appPrices[_key2];
            appPriceOptions.push((0, _preact.h)(
              'option',
              { key: _key2, value: _key2 },
              _price.name + ' - ' + formatter.format(_price.amount)
            ));
          }
        } else if (slug.indexOf(post.post_name + '-epubs') === 0) {
          epub = product.post;
          epubPrices = product.prices;
          for (var _key3 in epubPrices) {
            var _price2 = epubPrices[_key3];
            epubPriceOptions.push((0, _preact.h)(
              'option',
              { key: _key3, value: _key3 },
              _price2.name + ' - ' + formatter.format(_price2.amount)
            ));
          }
        } else if (slug.indexOf(post.post_name + '-webfont') === 0) {
          webfont = product.post;
          webfontPrices = product.prices;
          for (var _key4 in webfontPrices) {
            var _price3 = webfontPrices[_key4];
            webfontPriceOptions.push((0, _preact.h)(
              'option',
              { key: _key4, value: _key4 },
              _price3.name + ' - ' + formatter.format(_price3.amount)
            ));
          }
        } else if (slug.indexOf(post.post_name + '-multi-site') === 0) {
          multisite = product.post;
          multisitePrices = product.prices;
          for (var _key5 in multisitePrices) {
            var _price4 = multisitePrices[_key5];
            multisitePriceOptions.push((0, _preact.h)(
              'option',
              { key: _key5, value: _key5 },
              _price4.name + ' - ' + formatter.format(_price4.amount)
            ));
          }
        }
      }
    }

    var _state = this.state,
        selectedDesktopLicense = _state.selectedDesktopLicense,
        selectedWebfontLicense = _state.selectedWebfontLicense,
        selectedEpubLicense = _state.selectedEpubLicense,
        selectedAppLicense = _state.selectedAppLicense,
        selectedMultisiteLicense = _state.selectedMultisiteLicense;


    if (this.state.visible) {
      return (0, _preact.h)(
        'div',
        { className: 'modal-container', onClick: this.handleCloseClick },
        (0, _preact.h)(
          'div',
          { className: 'modal-box', onClick: this.handleBoxClick },
          (0, _preact.h)(
            'header',
            { className: 'modal-header' },
            (0, _preact.h)(
              'h1',
              null,
              'Buying Options'
            ),
            (0, _preact.h)(
              'div',
              { className: 'close-btn', onClick: this.handleCloseClick },
              (0, _preact.h)(
                'svg',
                { width: '14', height: '14', viewBox: '591 356 35 35' },
                (0, _preact.h)('path', { d: 'M625.1215,362.1215 L613.2425,374.0005 L625.1215,385.8785 C625.6635,386.4215 625.9995,387.1715 625.9995,387.9995 C625.9995,389.6575 624.6565,390.9995 622.9995,390.9995 C622.1715,390.9995 621.4215,390.6645 620.8785,390.1215 L608.9995,378.2425 L597.1215,390.1215 C596.5785,390.6645 595.8285,390.9995 594.9995,390.9995 C593.3435,390.9995 591.9995,389.6575 591.9995,387.9995 C591.9995,387.1715 592.3355,386.4215 592.8785,385.8785 L604.7575,374.0005 L592.8785,362.1215 C592.3355,361.5785 591.9995,360.8285 591.9995,359.9995 C591.9995,358.3435 593.3435,356.9995 594.9995,356.9995 C595.8285,356.9995 596.5785,357.3355 597.1215,357.8785 L608.9995,369.7575 L620.8785,357.8785 C621.4215,357.3355 622.1715,356.9995 622.9995,356.9995 C624.6565,356.9995 625.9995,358.3435 625.9995,359.9995 C625.9995,360.8285 625.6635,361.5785 625.1215,362.1215', stroke: 'none', fill: '#ffb4af', 'fill-rule': 'evenodd' })
              )
            )
          ),
          (0, _preact.h)(
            'div',
            { className: 'modal-body' },
            (0, _preact.h)(
              'div',
              { className: 'row-10 selection' },
              (0, _preact.h)(
                'div',
                { className: 'column cols-2 offset-left-1 label' },
                'Your Selection'
              ),
              (0, _preact.h)(
                'div',
                { className: 'column cols-4 typeface-preview' },
                post && (0, _preact.h)(_FontImage2.default, { id: post.ID, text: post.post_title, width: '374', height: '70', pointSize: '20', paddingTop: '24' })
              ),
              (0, _preact.h)(
                'div',
                { className: 'column cols-1 font-count' },
                post && post.fields && post.fields.children && post.fields.children.length > 1 ? post.fields.children.length + ' Fonts' : post.post_name.endsWith('collection') ? '1 Collection' : '1 Font'
              ),
              (0, _preact.h)(
                'div',
                { className: 'column cols-2 top-cart-button' },
                (0, _preact.h)(
                  'a',
                  { className: (0, _classnames2.default)('add-to-cart-button', this.state.addToCartUIDisabled && 'disabled'), href: '#', onClick: this.handleAddToCartClick },
                  'Add to Cart'
                )
              )
            ),
            (0, _preact.h)(
              'div',
              { className: 'row-10 licensing' },
              (0, _preact.h)(
                'div',
                { className: 'column cols-2 offset-left-1 label' },
                'Choose Licensing'
              ),
              (0, _preact.h)(
                'div',
                { className: 'column cols-5 licenses' },
                (0, _preact.h)(
                  'div',
                  { className: 'desktop license' },
                  (0, _preact.h)(
                    'div',
                    { className: 'icon' },
                    (0, _preact.h)(
                      'svg',
                      { width: '14', height: '13', viewBox: '514 356 34 32' },
                      (0, _preact.h)('path', { d: 'M516.143,377.3578 L545.072,377.3578 L545.072,359.1428 L516.143,359.1428 L516.143,377.3578 Z M545.608,381.6438 L537.572,381.6438 L535.429,381.6438 L535.429,384.3228 L537.572,386.4648 L537.572,387.0008 L523.643,387.0008 L523.643,386.4648 L525.786,384.3228 L525.786,381.6438 L523.643,381.6438 L515.607,381.6438 C514.72,381.6438 514,380.9238 514,380.0368 L514,358.6078 C514,357.7198 514.72,356.9998 515.607,356.9998 L545.608,356.9998 C546.495,356.9998 547.215,357.7198 547.215,358.6078 L547.215,380.0368 C547.215,380.9238 546.495,381.6438 545.608,381.6438 L545.608,381.6438 Z', id: 'Page-1', stroke: 'none', fill: '#000000', 'fill-rule': 'evenodd' })
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'label' },
                    (0, _preact.h)(
                      'label',
                      { 'for': 'desktop-options' },
                      post && post.post_name && post.post_name.indexOf('clearviewhwy') !== -1 ? 'Singlesite License' : 'Desktop License'
                    ),
                    (0, _preact.h)(
                      'a',
                      { href: '/licensing' },
                      'View license'
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'options' },
                    (0, _preact.h)(
                      'select',
                      { disabled: this.state.addToCartDisabled, id: 'desktop-options', onChange: this.handleDesktopChange },
                      priceOptions
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'price' },
                    selectedDesktopLicense && formatter.format(prices[selectedDesktopLicense].amount)
                  )
                ),
                webfontPriceOptions.length > 1 && (0, _preact.h)(
                  'div',
                  { className: 'webfont license' },
                  (0, _preact.h)(
                    'div',
                    { className: 'icon', style: 'line-height: 16px;' },
                    (0, _preact.h)(
                      'strong',
                      { style: 'font-size: 10px;' },
                      '</>'
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'label' },
                    (0, _preact.h)(
                      'label',
                      { 'for': 'webfont-options' },
                      'Webfont License'
                    ),
                    (0, _preact.h)(
                      'a',
                      { href: '/licensing' },
                      'View license'
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'options' },
                    (0, _preact.h)(
                      'select',
                      { disabled: this.state.addToCartDisabled, id: 'webfont-options', onChange: this.handleWebfontChange },
                      webfontPriceOptions
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'price' },
                    selectedWebfontLicense && formatter.format(webfontPrices[selectedWebfontLicense].amount)
                  )
                ),
                appPriceOptions.length > 1 && (0, _preact.h)(
                  'div',
                  { className: 'app license' },
                  (0, _preact.h)(
                    'div',
                    { className: 'icon' },
                    (0, _preact.h)(
                      'div',
                      { style: 'border: 2px solid black; border-radius: 3px; padding: 1px; display: inline-block;' },
                      (0, _preact.h)('img', { src: 'data:image/gif;base64,R0lGODlhBgAGAIAAAP///wAAACH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNyAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo5N0UyRkQ3OTEyQUMxMUU3QkIzMUFBQUQyOEU2RDQyQyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo5N0UyRkQ3QTEyQUMxMUU3QkIzMUFBQUQyOEU2RDQyQyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjk3RTJGRDc3MTJBQzExRTdCQjMxQUFBRDI4RTZENDJDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjk3RTJGRDc4MTJBQzExRTdCQjMxQUFBRDI4RTZENDJDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEAAAAAAAsAAAAAAYABgAAAgoEEmaol45YfM4UADs=',
                        width: '6', height: '6', style: 'display: block' })
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'label' },
                    (0, _preact.h)(
                      'label',
                      { 'for': 'app-options' },
                      'App License'
                    ),
                    (0, _preact.h)(
                      'a',
                      { href: '/licensing' },
                      'View license'
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'options' },
                    (0, _preact.h)(
                      'select',
                      { disabled: this.state.addToCartDisabled, id: 'app-options', onChange: this.handleAppChange },
                      appPriceOptions
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'price' },
                    selectedAppLicense && formatter.format(appPrices[selectedAppLicense].amount)
                  )
                ),
                epubPriceOptions.length > 1 && (0, _preact.h)(
                  'div',
                  { className: 'Epub license' },
                  (0, _preact.h)(
                    'div',
                    { className: 'icon' },
                    (0, _preact.h)(
                      'div',
                      { style: 'display: inline-block' },
                      (0, _preact.h)('img', { src: 'data:image/gif;base64,R0lGODlhCgANAIAAAAEBAf///yH/C1hNUCBEYXRhWE1QPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgMjAxNyAoTWFjaW50b3NoKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo5N0UyRkQ3RDEyQUMxMUU3QkIzMUFBQUQyOEU2RDQyQyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo5N0UyRkQ3RTEyQUMxMUU3QkIzMUFBQUQyOEU2RDQyQyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjk3RTJGRDdCMTJBQzExRTdCQjMxQUFBRDI4RTZENDJDIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjk3RTJGRDdDMTJBQzExRTdCQjMxQUFBRDI4RTZENDJDIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+Af/+/fz7+vn49/b19PPy8fDv7u3s6+rp6Ofm5eTj4uHg397d3Nva2djX1tXU09LR0M/OzczLysnIx8bFxMPCwcC/vr28u7q5uLe2tbSzsrGwr66trKuqqainpqWko6KhoJ+enZybmpmYl5aVlJOSkZCPjo2Mi4qJiIeGhYSDgoGAf359fHt6eXh3dnV0c3JxcG9ubWxramloZ2ZlZGNiYWBfXl1cW1pZWFdWVVRTUlFQT05NTEtKSUhHRkVEQ0JBQD8+PTw7Ojk4NzY1NDMyMTAvLi0sKyopKCcmJSQjIiEgHx4dHBsaGRgXFhUUExIREA8ODQwLCgkIBwYFBAMCAQAAIfkEAAAAAAAsAAAAAAoADQAAAheEjxDLa5HUa+xFqKiTCeuNTd4nUtGJFgA7',
                        width: '10', height: '13', style: 'display: block; image-rendering: pixelated' })
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'label' },
                    (0, _preact.h)(
                      'label',
                      { 'for': 'epub-options' },
                      'Epub License'
                    ),
                    (0, _preact.h)(
                      'a',
                      { href: '/licensing' },
                      'View license'
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'options' },
                    (0, _preact.h)(
                      'select',
                      { disabled: this.state.addToCartDisabled, id: 'epub-options', onChange: this.handleEpubChange },
                      epubPriceOptions
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'price' },
                    selectedEpubLicense && formatter.format(epubPrices[selectedEpubLicense].amount)
                  )
                ),
                multisitePriceOptions.length > 1 && (0, _preact.h)(
                  'div',
                  { className: 'multisite license' },
                  (0, _preact.h)(
                    'div',
                    { className: 'icon' },
                    (0, _preact.h)(
                      'svg',
                      { width: '14', height: '13', viewBox: '514 356 34 32' },
                      (0, _preact.h)('path', { d: 'M516.143,377.3578 L545.072,377.3578 L545.072,359.1428 L516.143,359.1428 L516.143,377.3578 Z M545.608,381.6438 L537.572,381.6438 L535.429,381.6438 L535.429,384.3228 L537.572,386.4648 L537.572,387.0008 L523.643,387.0008 L523.643,386.4648 L525.786,384.3228 L525.786,381.6438 L523.643,381.6438 L515.607,381.6438 C514.72,381.6438 514,380.9238 514,380.0368 L514,358.6078 C514,357.7198 514.72,356.9998 515.607,356.9998 L545.608,356.9998 C546.495,356.9998 547.215,357.7198 547.215,358.6078 L547.215,380.0368 C547.215,380.9238 546.495,381.6438 545.608,381.6438 L545.608,381.6438 Z', id: 'Page-1', stroke: 'none', fill: '#000000', 'fill-rule': 'evenodd' })
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'label' },
                    (0, _preact.h)(
                      'label',
                      { 'for': 'multisite-options' },
                      'Multisite License'
                    ),
                    (0, _preact.h)(
                      'a',
                      { href: '/licensing' },
                      'View license'
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'options' },
                    (0, _preact.h)(
                      'select',
                      { disabled: this.state.addToCartDisabled, id: 'multisite-options', onChange: this.handleMultisiteChange },
                      multisitePriceOptions
                    )
                  ),
                  (0, _preact.h)(
                    'div',
                    { className: 'price' },
                    selectedMultisiteLicense && formatter.format(multisitePrices[selectedMultisiteLicense].amount)
                  )
                )
              )
            ),
            (0, _preact.h)(
              'div',
              { className: 'row-10 total' },
              (0, _preact.h)(
                'div',
                { className: 'column cols-2 offset-left-3' },
                'Total'
              ),
              (0, _preact.h)(
                'div',
                { className: 'column cols-3 price' },
                formatter.format((selectedDesktopLicense ? parseFloat(prices[selectedDesktopLicense].amount) : 0) + (selectedWebfontLicense ? parseFloat(webfontPrices[selectedWebfontLicense].amount) : 0) + (selectedEpubLicense ? parseFloat(epubPrices[selectedEpubLicense].amount) : 0) + (selectedAppLicense ? parseFloat(appPrices[selectedAppLicense].amount) : 0) + (selectedMultisiteLicense ? parseFloat(multisitePrices[selectedMultisiteLicense].amount) : 0))
              )
            ),
            (0, _preact.h)(
              'div',
              { className: 'checkout' },
              (0, _preact.h)(
                'a',
                { className: (0, _classnames2.default)('add-to-cart-button', this.state.addToCartUIDisabled && 'disabled'), href: '#', onClick: this.handleAddToCartClick },
                'Add to Cart'
              )
            )
          ),
          (0, _preact.h)(
            'footer',
            null,
            (0, _preact.h)(
              'div',
              { className: 'left' },
              (0, _preact.h)(
                'p',
                null,
                'Sales Tax of 8.875% is collected ',
                (0, _preact.h)('br', null),
                'for New York State residents.'
              ),
              (0, _preact.h)(
                'p',
                null,
                'Buy fonts with a ',
                (0, _preact.h)(
                  'a',
                  { href: '/contact' },
                  'Purchase Order'
                )
              )
            ),
            (0, _preact.h)(
              'div',
              { className: 'middle' },
              (0, _preact.h)(
                'p',
                null,
                'Once fonts have been downloaded',
                (0, _preact.h)('br', null),
                'no refunds will be given.'
              )
            ),
            (0, _preact.h)(
              'div',
              { className: 'right' },
              (0, _preact.h)(
                'p',
                null,
                'Questions?',
                (0, _preact.h)('br', null),
                (0, _preact.h)(
                  'a',
                  { href: '/contact' },
                  'Please Contact Us.'
                )
              )
            )
          )
        )
      );
    } else {
      return null;
    }
  };

  return BuyingOptions;
}(_preact.Component);

exports.default = BuyingOptions;


function getAddToCartData(download_id, option, nonce) {
  return {
    action: 'edd_add_to_cart',
    'price_ids%5B%5D': option,
    download_id: download_id,
    nonce: nonce
  };
}
function doCartRequest(params, cb) {
  var req = new Request('/wp-admin/admin-ajax.php');

  var body = [];
  for (var key in params) {
    body.push(key + '=' + params[key]);
  }

  fetch(req, {
    method: 'POST',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    credentials: 'include',
    redirect: 'manual',
    body: body.join('&')
  }).then(function (response) {
    cb(response);
  }, function (error) {
    console.error(error);
  });
}

// polyfill: https://philipwalton.com/articles/loading-polyfills-only-when-needed/
function hasAllPolyfills() {
  return window.Intl && window.fetch;
}
if (!hasAllPolyfills()) {
  (0, _loadScript2.default)('https://cdn.polyfill.io/v2/polyfill.min.js?features=Intl,fetch');
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = loadScript;
function loadScript(src, done) {
  var js = document.createElement('script');
  js.src = src;
  if (done) {
    js.onload = function () {
      done();
    };
    js.onerror = function () {
      done(new Error('Failed to load script ' + src));
    };
  }
  document.head.appendChild(js);
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = classnames;
function classnames() {
  for (var _len = arguments.length, classnames = Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (c) {
    return !!c;
  }).join(' ');
}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js